@if ((loaded$ | async) == true) {
  <form [formGroup]="identificationFormGroup" class="frame">
    <h1 data-testid="title" [attr.color]="TRANSLATE_PATH_SHARED.COLOR_TITLE | translate ">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_TITLE | translate}}</h1>
    <div class="row">
      <div data-testid="introduction" [innerHTML]="(TRANSLATE_PATH_PROJECT.IDENTIFICATION_INTRODUCTION | translate)"></div>
      <div class="control-field" [attr.data-m-max-width]="FIELDWIDTH.MAX">
        <mat-form-field [appearance]="TRANSLATE_PATH_SHARED.FIELDMODE| translate | appearance">
          <mat-label data-testid="code-label">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_LABEL | translate}}</mat-label>
          <input data-testid="code-input" UuidIsValid matInput name="uuid" formControlName="formControlUuid" placeholder="{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_PLACEHOLDER | translate}}" required>
          @if (identificationFormGroup.get('formControlUuid')?.hasError('pattern')) {
            <mat-error data-testid="code-error-pattern">
              {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_ERROR_PATTERN | translate}}
            </mat-error>
          }
          @if (identificationFormGroup.get('formControlUuid')?.hasError('required')) {
            <mat-error data-testid="code-error-required">
              {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_ERROR_REQUIRED | translate}}
            </mat-error>
          }
          @if (identificationFormGroup.get('formControlUuid')?.hasError('codeNotExists')) {
            <mat-error data-testid="code-error-notExists">
              {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_ERROR_NOTEXISTS | translate}}
            </mat-error>
          }
          @if (identificationFormGroup.get('formControlUuid')?.hasError('consultant')) {
            <mat-error data-testid="code-error-consultant">
              {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_ERROR_CONSULTANT | translate}}
            </mat-error>
          }
          @if (identificationFormGroup.valid && !withBirthday) {
            <mat-hint data-testid="code-hint">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_HINT | translate}}</mat-hint>
          }
          @if (identificationFormGroup.valid && identificationFormGroup.controls.code != undefined && identificationFormGroup.controls.code.pending) {
            <mat-hint data-testid="code-pending">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_CODE_PENDING | translate}}</mat-hint>
          }
        </mat-form-field>
        @if (!sValidationBirthday.isModule) {
          @if (withBirthday) {
            <mat-form-field [appearance]="TRANSLATE_PATH_SHARED.FIELDMODE| translate | appearance">
              <mat-label data-testid="birthday-label" [innerHTML]="TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_LABEL | translate"></mat-label>
              <input data-testid="birthday-input" BirthdayIsValid formControlName="formControlBirthday" required matInput [matDatepicker]="picker" placeholder="{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_PLACEHOLDER | translate}}">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
              @if (identificationFormGroup.get('formControlBirthday')?.hasError('birthdayWrongFormat')) {
                <mat-error data-testid="birthday-error-pattern">
                  {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_ERROR_PATTERN | translate}}
                </mat-error>
              }
              @if (identificationFormGroup.get('formControlBirthday')?.hasError('required')) {
                <mat-error data-testid="birthday-error-required">
                  {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_ERROR_REQUIRED | translate}}
                </mat-error>
              }
              @if (identificationFormGroup.get('formControlBirthday')?.hasError('birthdayNotExists')) {
                <mat-error data-testid="birthday-error-notExists">
                  {{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_ERROR_NOTEXISTS | translate}}
                </mat-error>
              }
              @if (identificationFormGroup.valid && withBirthday) {
                <mat-hint data-testid="birthday-hint">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_HINT | translate}}</mat-hint>
              }
              @if (identificationFormGroup.valid && identificationFormGroup.controls.formControlBirthday.pending ) {
                <mat-hint data-testid="birthday-pending">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BIRTHDAY_PENDING | translate}}</mat-hint>
              }
            </mat-form-field>
          }
        }
      </div>
    </div>
    <div class="row">
      <app-field-item-row data-testid="toggle-row" [fieldMeta]="sIdentification.questionMeta" formControlName="toggle"></app-field-item-row>
    </div>
    @if ((TRANSLATE_PATH_PROJECT.IDENTIFICATION_INFO_TEXT | translate).length > 0 && (TRANSLATE_PATH_PROJECT.IDENTIFICATION_INFO_TEXT | translate) !== TRANSLATE_PATH_PROJECT.IDENTIFICATION_INFO_TEXT) {
      <div [innerHTML]="(TRANSLATE_PATH_PROJECT.IDENTIFICATION_INFO_TEXT | translate)"></div>
    }
    <div class="flex-end">
      <button data-testid="button" mat-raised-button [color]="TRANSLATE_PATH_SHARED.COLOR_REDIRECT | translate" (click)="onNextClick()" [disabled]="identificationFormGroup.pending || identificationFormGroup.invalid">{{TRANSLATE_PATH_PROJECT.IDENTIFICATION_BUTTON | translate}}</button>
    </div>
  </form>
}
